import { type FC, type PropsWithChildren, type ReactNode, type JSX } from 'react';

import { iconListIconStyle, iconListItemStyle, iconListTextStyle } from './IconListItem.css';

type Props = {
  /** Text shown inside the list item */
  children: ReactNode;
  /** Icon shown inside the list item. */
  icon?: JSX.Element;
};

export const IconListItem: FC<PropsWithChildren<Props>> = ({ children, icon }) => {
  return (
    <li className={iconListItemStyle}>
      <div className={iconListIconStyle}>{icon}</div>
      <div className={iconListTextStyle}>{children}</div>
    </li>
  );
};
